export const optionDataGrid = {
  rowsPerPageOptions: [15, 30, 45, 60]
};
